// extracted by mini-css-extract-plugin
export default {"container":"drawer_container__7EHQH","visible":"drawer_visible__5MI5X","window":"drawer_window__EQ6xV","not-visible":"drawer_not-visible__N4XSf","menu":"drawer_menu__sdvtU"};